<template>
  <el-dialog
    :close-on-click-modal="false"
    title="对账调整"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <el-table ref="multipleTable" :data="diffListData" tooltip-effect="dark">
        <el-table-column prop="diffTypeName" label="类型" />
        <el-table-column prop="diffFeeDouble" label="金额">
          <section slot-scope="scope">
            <el-input v-model="scope.row.diffFeeDouble" />
          </section>
        </el-table-column>
        <el-table-column prop="diffDesc" label="说明">
          <section slot-scope="scope">
            <el-input v-model="scope.row.diffDesc" />
          </section>
        </el-table-column>
      </el-table>
    </section>
    <section slot="footer" class="dialog-footer">
      <qx-permpisions permpisions="">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <el-button type="primary" @click="sub" :loading="subLoading || getDetailLoading">确 定</el-button>
      </qx-permpisions>
    </section>
  </el-dialog>
</template>

<script>
import {
  getOrderDiffList,
  saveOrderDiff,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      diffListData: [],
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.getDetailLoading = true;
      const res = await getOrderDiffList({
        orderId: item.orderId,
      });
      this.diffListData = res.items;
      this.getDetailLoading = false;
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await saveOrderDiff({
        orderId: this.originData.orderId,
        listData: JSON.stringify(this.diffListData),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
